import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import {
  Scale,
  Gavel,
  Briefcase,
  FileText,
  Users,
  Building,
  Home,
  Car,
  Heart,
  Shield,
  Landmark,
  ScrollText,
} from 'lucide-react';

const ICONS = [
  { id: 'scale', name: 'Balança (Justiça)', Icon: Scale },
  { id: 'gavel', name: 'Martelo (Juiz)', Icon: Gavel },
  { id: 'briefcase', name: 'Maleta (Trabalho)', Icon: Briefcase },
  { id: 'file-text', name: 'Documento', Icon: FileText },
  { id: 'users', name: 'Pessoas (Família)', Icon: Users },
  { id: 'building', name: 'Prédio (Empresarial)', Icon: Building },
  { id: 'home', name: 'Casa (Imobiliário)', Icon: Home },
  { id: 'car', name: 'Carro (Trânsito)', Icon: Car },
  { id: 'heart', name: 'Coração (Saúde)', Icon: Heart },
  { id: 'shield', name: 'Escudo (Defesa)', Icon: Shield },
  { id: 'landmark', name: 'Tribunal', Icon: Landmark },
  { id: 'scroll-text', name: 'Contrato', Icon: ScrollText },
];

interface IconSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export function IconSelector({ value, onChange }: IconSelectorProps) {
  return (
    <div className="space-y-2">
      <Label>Ícone do Caso</Label>
      <div className="grid grid-cols-4 gap-2">
        {ICONS.map(({ id, name, Icon }) => (
          <button
            key={id}
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onChange(id);
            }}
            className={cn(
              "flex items-center justify-center h-12 rounded-md transition-all",
              "border-2 hover:bg-accent",
              value === id
                ? "border-primary bg-accent"
                : "border-muted"
            )}
            title={name}
          >
            <Icon className="h-5 w-5" />
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        {ICONS.find(i => i.id === value)?.name || 'Selecione um ícone'}
      </p>
    </div>
  );
}
